import { createUser, resendVerifyCode } from "api/mutations/user";
import { updateUser } from "api/mutations/user/user";
import { getUser } from "api/queries/user";
import { userVerify } from "api/queries/user/user";
import { TCreateUserBody, TCreateUserResponse } from "interface";
import {
  useMutation, UseMutationResult, useQuery, UseQueryOptions
} from "react-query";
import { IError } from "rules/interface/api/error.interface";
import { IApiRequest, IApiRequestDataWithId, IServerResponse } from "rules/interface/api/response";
import IUserResendVerifyCodeBody from "rules/interface/api/user/resend-verify-code-body.interface";
import IUpdateUser from "rules/interface/api/user/update-user.interface";
import IUser from "rules/interface/user/user.interface";
import IUserVerifyBody from "rules/interface/user/verify-body.interface";
import IUserVerify from "rules/interface/user/verify.interface";


export const useCreateUser = (): UseMutationResult<
  IServerResponse<TCreateUserResponse>,
  IError,
  TCreateUserBody
> => {
  return useMutation(body => createUser(body));
};

export const useUpdateUser = (): UseMutationResult<
  IServerResponse<{}>,
  IError,
  IApiRequestDataWithId<IUpdateUser>
> => {
  return useMutation(body => updateUser(body));
}

interface IParams {
  id: string
  options?: UseQueryOptions<IServerResponse<IUser>>
}

export const useGetUser = (params: IParams) => {
  return useQuery(
    ["project", params],
    () => getUser(params),
    params.options
  );
}

export const useVerify = (): UseMutationResult<IServerResponse<IUserVerify>, IError, IApiRequest<IUserVerifyBody>> => {
  return useMutation(body => userVerify(body));
}

export const useResendVerifyCode = (): UseMutationResult<IServerResponse<{}>, IError, IApiRequest<IUserResendVerifyCodeBody>> => {
  return useMutation(body => resendVerifyCode(body));
}